<template>
        <b-card>
        <template v-slot:header>
            <b-row>
                <b-col>
                    Flag-Role Permissions Table
                </b-col>
                <b-col class="text-right">
                    <b-button v-if="!editPermissions"
                              variant="secondary"
                              @click="editPermissions = !editPermissions"
                              class="float-right"
                              size="sm">
                        <i class="fa-light fa-edit"></i>
                    </b-button>
                    <template v-if="editPermissions">
                        <!--<b-button disabled size="sm" v-if="editPermissions" @click="openCreateNewRoleModal" variant="primary">Add Role <i class="ml-1 fa-regular fa-plus"></i></b-button> -->


                        <b-button class="mx-2" variant="success" size="sm" @click="savePermissionEdits">
                                    <span v-if="savingRoles">
                                        Saving <i class="fa-solid fa-spinner fa-spin"></i>
                                    </span>
                            <span v-else>
                                        Save Edits <i class="ml-1 fa-regular fa-save"></i>
                                    </span>

                        </b-button>

                        <b-button size="sm" @click="cancelPermissionEdits">Cancel <i class="ml-1 fa-light fa-times"></i>
                        </b-button>
                    </template>
                </b-col>
            </b-row>
        </template>

        <div class="bg-gray-200" v-if="dataLoaded">
                <b-container class="small-text-display p-2" slot="thead-top">
                    <b-row>
                        <b-col cols="4"><i class="text-success fa fa-fw fa-plus"></i> - Role can create Flags </b-col>
                        <b-col cols="4"> <i class="text-primary fa fa-fw fa-user-tag"></i> - Role can be assigned to flag </b-col>
                        <b-col cols="4"><i class="text-warning fa fa-fw fa-user-check"></i> - Role is auto-assigned to flag </b-col>
                        <b-col cols="4"><i class="text-warning fa-solid fa-fw fa-bell"></i> - Role is notified of flag creation</b-col>
                        <b-col cols="4"><i class="text-warning fa-solid fa-fw fa-message-exclamation"></i> - Role is notified of flag updates</b-col>
                        <b-col cols="4"><i class="text-warning fa-solid fa-solid fa-fw fa-file-arrow-up"></i> - Role is notified of Document uploads </b-col>
                        <b-col cols="4"><i class="text-warning fa fa-fw fa-solid fa-warning"></i> - Role is notified of Specialized warning </b-col>
                        <b-col cols="4"><i class="text-danger fa fa-solid fa-trash mr-1"></i> - Role can clear flag </b-col>
                    </b-row>
                </b-container>
        </div>
        <div>
            <b-table responsive
                     sticky-header
                     bordered
                     v-if="dataLoaded"
                     :fields="flagPerRole"
                     :items="roles">
                <template v-slot:head()="data">
                    <div class="text-center font-xs">{{ data.label }} </div>
                </template>
                <template v-slot:cell(role)="data">
                    <span class="">{{ alterName(data.item.name) }}</span>
                </template>
                <template v-slot:cell()="data" >
                    <div :style="'min-width:' + (100 + (data.field.capabilities.is_manually_selectable ? 40 : 0) + (data.field.capabilities.hasSpecialAlert ? 20 : 0) + (data.field.capabilities.hasDocument ? 20 : 0)) + 'px'">
                        <template >
                            <div v-on:mouseover="startHoverElements(data.item, data.field.id)" class="text-center">
                                <i v-on:click = "updateRole(data.item, data.field.id, 'can_create')" v-if = "data.field.capabilities.is_manually_selectable" :class="getFlagRoleReference(data.item, data.field.id).can_create ? 'text-success' : 'text-faded'" :id="'can_create_' + data.item.id + '_' + data.field.id" class="fa fa-fw fa-plus mr-1"></i>
                                <i v-on:click = "updateRole(data.item, data.field.id, 'can_assign')" v-if = "data.field.capabilities.is_manually_selectable" :class="getFlagRoleReference(data.item, data.field.id).can_assign ? 'text-info' : 'text-faded'"  :id="'can_assign_' + data.item.id + '_' + data.field.id" class="fa fa-fw fa-user-tag mr-2"></i>
                                <i v-on:click = "updateRole(data.item, data.field.id, 'auto_assign')" v-if="data.item.name != 'Read Only'" :class="getFlagRoleReference(data.item, data.field.id).auto_assign ? 'text-warning' : 'text-faded'" :id="'auto_assign_' + data.item.id + '_' + data.field.id" class="fa fa-fw fa-user-check mr-1"></i>
                                <i v-on:click = "updateRole(data.item, data.field.id, 'notify_flag_created')"  v-if="data.item.name != 'Read Only'" :class="getFlagRoleReference(data.item, data.field.id).notify_flag_created ? 'text-warning' : 'text-faded'" :id="'notify_created_' + data.item.id + '_' + data.field.id" class="fa-solid fa-fw fa-bell mr-1"></i>
                                <i v-on:click = "updateRole(data.item, data.field.id, 'notify_flag_updated')"  v-if="data.item.name != 'Read Only'" :class="getFlagRoleReference(data.item, data.field.id).notify_flag_updated ? 'text-warning' : 'text-faded'" :id="'notify_updated_' + data.item.id + '_' + data.field.id" class="fa-solid fa-fw fa-message-exclamation mr-1"></i>
                                <i v-on:click = "updateRole(data.item, data.field.id, 'notify_document_uploaded')" v-if = "data.item.name != 'Read Only' && data.field.capabilities.hasDocument" :class="getFlagRoleReference(data.item, data.field.id).notify_document_uploaded ? 'text-warning' : 'text-faded'" :id="'notify_document_' + data.item.id + '_' + data.field.id" class="fa-solid fa-solid fa-fw fa-file-arrow-up mr-1"></i>
                                <i v-on:click = "updateRole(data.item, data.field.id, 'notify_alert')" v-if = "data.item.name != 'Read Only' && data.field.capabilities.hasSpecialAlert" :class="getFlagRoleReference(data.item, data.field.id).notify_alert ? 'text-warning' : 'text-faded'" :id="'notify_alert_' + data.item.id + '_' + data.field.id" class="fa fa-fw fa-solid fa-warning mr-1"></i>
                                <i v-on:click = "updateRole(data.item, data.field.id, 'can_remove')" :class="getFlagRoleReference(data.item, data.field.id).can_remove ? 'text-danger' : 'text-faded'" :id="'can_delete_' + data.item.id + '_' + data.field.id" class="fa fa-solid fa-trash mr-1"></i>

                                <template v-if="isShowingTooltip(data.item, data.field.id)">
                                    <b-popover ref="popover" :id="'description-can_assign_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               v-if = "data.field.capabilities.is_manually_selectable"
                                               :title="alterName2(data.item.name) + ' can' + (getFlagRoleReference(data.item, data.field.id).can_assign ? '' : 'not') + ' be Assigned to Flag ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'can_assign_' + data.item.id + '_' + data.field.id">
                                        <div class="container"><span v-if="data.item.name != 'Read Only'">Determines that the role </span>{{alterName2(data.item.name)}} can be assigned to the flag {{data.field.label}}.</div>
                                    </b-popover>
                                    <b-popover v-if = "data.field.capabilities.is_manually_selectable" ref="popover" :id="'description-can_create_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               :title="alterName2(data.item.name) + ' can' + (getFlagRoleReference(data.item, data.field.id).can_create ? '' : 'not') + ' create the flag ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'can_create_' + data.item.id + '_' + data.field.id">
                                        <div class="container"><span v-if="data.item.name != 'Read Only'">Determines that the role </span>{{alterName2(data.item.name)}} can create the flag {{data.field.label }}.</div>
                                    </b-popover>
                                    <b-popover ref="popover" :id="'description-auto_assign_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               title="Role is auto assigned flag"
                                               :title="alterName2(data.item.name) + ' will' + (getFlagRoleReference(data.item, data.field.id).auto_assign ? '' : ' not') + ' be auto assigned to flag ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'auto_assign_' + data.item.id + '_' + data.field.id">
                                        <div class="container">Determines that the role {{alterName2(data.item.name)}} will be automatically assigned the flag {{data.field.label }}.</div>
                                    </b-popover>
                                    <b-popover ref="popover" :id="'description-notify_created_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               :title="alterName2(data.item.name) + ' will' + (getFlagRoleReference(data.item, data.field.id).notify_flag_created ? '' : ' not') + ' be notified of flag created for ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'notify_created_' + data.item.id + '_' + data.field.id">
                                        <div class="container">Determines that the role {{alterName2(data.item.name)}} will receive notifications when a flag is created, regardless if they are assigned or not, for {{data.field.label }}.</div>
                                    </b-popover>
                                    <b-popover ref="popover" :id="'description-notify_updated_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               :title="alterName2(data.item.name) + ' will' + (getFlagRoleReference(data.item, data.field.id).notify_flag_updated ? '' : ' not') + '  be notified of flag updated for ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'notify_updated_' + data.item.id + '_' + data.field.id">
                                        <div class="container">Determines that the role {{alterName2(data.item.name)}} will receive notifications when a flag is updated, regardless if they are assigned or not, for {{data.field.label }}.</div>
                                    </b-popover>
                                    <b-popover ref="popover" v-if = "data.field.capabilities.hasDocument" :id="'description-notify_document_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               :title="alterName2(data.item.name) + ' will' + (getFlagRoleReference(data.item, data.field.id).notify_document_uploaded ? '' : ' not') + ' be notified of document upload for ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'notify_document_' + data.item.id + '_' + data.field.id">
                                        <div class="container">Determines that the role {{alterName2(data.item.name)}} will receive notifications when a document related to the flag is uploaded/signed, regardless if they are assigned or not, for {{data.field.label}}.</div>
                                    </b-popover>
                                    <b-popover v-if = "data.field.capabilities.hasSpecialAlert" ref="popover" :id="'description-notify_special_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               :title="alterName2(data.item.name) + ' will' +  (getFlagRoleReference(data.item, data.field.id).notify_alert ? '' : ' not') + ' special notified for ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'notify_alert_' + data.item.id + '_' + data.field.id">
                                        <div class="container">Determines that the role {{alterName2(data.item.name)}} will receive a specialized notification under specific programmed conditions, IE, rescind expire date, for {{data.field.label}}.</div>
                                    </b-popover>
                                    <b-popover ref="popover" :id="'description-can_delete_' + data.index + '_' + data.field.id"
                                               placement="bottom"
                                               :title="alterName2(data.item.name) + ' can' + (getFlagRoleReference(data.item, data.field.id).can_remove ? '' : 'not') + ' clear the flag ' + (data.field.label)"
                                               triggers="hover"
                                               :target="'can_delete_' + data.item.id + '_' + data.field.id">
                                        <div class="container"><span v-if="data.item.name != 'Read Only'">Determines that the role </span>{{alterName2(data.item.name)}} can clear the flag {{data.field.label }}.</div>
                                    </b-popover>
                                </template>
                            </div>
                        </template>
                    </div>
                </template>
            </b-table>
            <loading-spinner :busy="!dataLoaded"></loading-spinner>
        </div>
    </b-card>
</template>

<script>
    import LoadingSpinner from "../../../components/LoadingSpinner";
    export default {
        name: 'flag-type-permissions',
        components: {LoadingSpinner},
        data () {
            return {
                flagPerRole: null,
                editPermissions: false,
                savingRoles: false,
                dataLoaded: false,
                roles: [],
                backRoles: [],
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                this.$http.all([
                    this.$http.get('/flag-types?appends=capabilities'), //get All flag types
                    this.$http.get('/roles?include=flagTypes'),
                ]).then(this.$http.spread((flagTypeData, roleTypeData) => {
                        console.log(flagTypeData);
                        console.log(roleTypeData);

                        this.flagPerRole = flagTypeData.data.data.map(item =>({key: item.name.replace(/ /g, '_'),label: item.name, id: item.id, capabilities: item.capabilities}));

                        this.flagPerRole.unshift({key: 'role', label: '', stickyColumn: true});
                        _.forEach(roleTypeData.data.data, (role) => {
                            role.hasUpdated = false;
                            _.forEach(flagTypeData.data.data, (flagType) => {
                                let flagReference = this.getFlagRoleReference(role, flagType.id);
                                if (!flagReference) {
                                    flagReference = {
                                        auto_assign: 0,
                                        can_assign: 0,
                                        can_create: 0,
                                        can_remove: 0,
                                        notify_document_uploaded: 0,
                                        notify_flag_created: 0,
                                        notify_flag_updated: 0,
                                        notify_alert: 0,
                                        id: flagType.id
                                    };
                                    role.flagTypes.data.push(flagReference);
                                }
                                flagReference.show_tooltip = false;
                            });
                        });

                        this.roles = roleTypeData.data.data;
                        this.roles = _.filter(this.roles, (role) => {
                            return role.name != "Super Admin";
                        });
                        this.backRoles = _.cloneDeep(this.roles);
                        this.dataLoaded = true;
                    })
                );
            },
            updateRole(role, flagtype_id, field) {
                if (this.editPermissions == false) {
                    this.editPermissions = true;
                }
                let FlagTypeReference = this.getFlagRoleReference(role, flagtype_id);
                FlagTypeReference[field] = FlagTypeReference[field] == 1 ? 0 : 1;
                role.hasUpdated = true;
                this.$forceUpdate();
            },
            savePermissionEdits() {
                this.savingRoles = true;
                let toUpdate = [];
                _.forEach(this.roles, (role) => {
                    if(role.hasUpdated) {
                        console.log(role);
                        toUpdate.push(this.$http.post('/roles/flag-type/' + role.id, role.flagTypes.data));
                    }
                });
                if(toUpdate.length == 0) {
                    this.savingRoles = false;
                    this.editPermissions = false;
                } else {
                    this.$http.all(toUpdate).then(() => {
                        this.backRoles = _.cloneDeep(this.roles);
                        this.editPermissions = false;
                    }).finally(() => {
                        this.savingRoles = false;
                    });
                }
            },
            cancelPermissionEdits() {
                this.editPermissions = false;
                this.roles = _.cloneDeep(this.backRoles);
                this.$forceUpdate();
            },
            alterName(name) {
                if(name == "Read Only") {
                    return "Global";
                }
                return name;
            },
            alterName2(name) {
                if(name == "Read Only") {
                    return "All";
                }
                return name;
            },
            toTitleCase(str) {
                return str.replaceAll('-', ' ').replace(
                    /\w\S*/g,
                    function(txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    }
                );
            },
            //optimization to prevent 20 seconds loadup in vuejs
            startHoverElements(role, flagtype_id) {
                this.getFlagRoleReference(role, flagtype_id).show_tooltip = true;
                this.$forceUpdate();
            },
            isShowingTooltip(role, flagtype_id) {
                return this.getFlagRoleReference(role, flagtype_id).show_tooltip;
            },
            getFlagRoleReference(role, flagtype_id) {
                let result = _.find(role.flagTypes.data, (flagType) => {
                    if(flagtype_id == flagType.id) {
                        return true;
                    }
                    return false;
                });
                return result;
            },
            printout(data) {
                console.log(data);
                return data;
            }
        },

    }

</script>

<style scoped>

    .b-table-sticky-header {
        max-height: 700px !important;
    }
    .custom-control-input:checked ~
    .custom-control-label::before {
        border-color: green;
        background-color: green;
    }
    .text-faded {
        color: rgba(0,0,0,0.15);
    }
    .small-text-display {
        font-size: 11px;
    }
</style>
